export default __webpack_public_path__ + "static/media/ContestUser.d5fe6690.svg";